// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"42cc2f93","380":"af7af821","419":"4af7bd06","720":"cd232ab7","774":"73eae487","775":"9b9b5141","842":"2f6684bd","883":"4405a70d","942":"2e386094"}[chunkId] + ".chunk.js";
};